/**
 * One page half's trim width, floored: the spread's full `trimWidth` split in two. Every document
 * layer that splits the spread at the spine starts from this value.
 */
export function computeHalfTrimWidth(trimWidth: number): number {
  return Math.max(0, Math.floor(trimWidth / 2))
}

/**
 * One page half's trim width, split at the shared device-pixel-snapped spine seam when one is given
 * (the ruler "0" tick, spine bar and dashed trim all draw at it), so the split can't drift a
 * fraction of a point off that seam. Falls back to {@link computeHalfTrimWidth} when no seam is
 * passed (stories/tests).
 */
export function computeSnappedPageTrimWidth(
  bleedMargin: number,
  trimWidth: number,
  spineSnapCanvasX?: number
): number {
  return spineSnapCanvasX != null
    ? Math.max(0, spineSnapCanvasX - bleedMargin)
    : computeHalfTrimWidth(trimWidth)
}
